import { all, takeEvery } from 'redux-saga/effects'

import { ApiUsageActions } from '../actions'
import { fetchApiUsage } from './fetchApiUsage'

export function* apiUsageSaga() {
  yield all([takeEvery(ApiUsageActions.fetch, fetchApiUsage)])
}
